import { IGlobalState } from '~reducer';
import ICountry from './ICountry';

export function countriesSelector(state: IGlobalState): ICountry[] {
    return state.countries.countries;
}
